export default function (data) {
  let status;
  if (data.ripSubmissionStatus == undefined) {
    return '';
  }

  let createDate = data.submitStatusInformation?.ksfLastLogInformation?.lastSuccessCreateDate;
  let submitDate = createDate ? moment(createDate).format('MMM DD, YYYY, HH:mm') : '';
  let id = data.submitStatusInformation?.ksfLastLogInformation?.correlationId;
  let submitDateUI = '';

  if (submitDate) {
    submitDateUI = `<span className="rip-status-date pl-2">${submitDate}</span>`;
  }

  switch (data.ripSubmissionStatus) {
    case 1:
      status = 'inprocess';
      break;
    case 2:
      status = 'submited';
      break;
    case 3:
      status = 'failed';
      break;
    default:
      status = 'notsubmited';
      break;
  }
  return id
    ? `<span class="rip-status rip-${status}">
          <span class="rip-status-notsubmited status-label text-muted mr-n4" data-aid="status-muted"><i class="far fa-fw fa-vote-nay mr-1"></i>${$Lang.BOM.RIPnotSubmitted}</span>
          <span class="rip-status-submited status-label text-success mr-n4" data-aid="status-submited"><i class="far fa-fw fa-vote-yea mr-1"></i>${$Lang.BOM.RIPfiles}</span>
          <span class="rip-status-inprocess status-label text-warning mr-n4" data-aid="status-warning"><i class="far fa-fw fa-sync-alt mr-1"></i>${$Lang.BOM.RIPinprocess}</span>
          <span class="rip-status-failed status-label text-danger mr-n4" data-aid="status-danger"><i class="far fa-fw fa-exclamation-triangle mr-1"></i>${$Lang.BOM.RIPfiles}</span>
          <span class="d-inline-flex text-nowrap ml-4">
            ${submitDateUI}
            <span class="pl-3"><i class="js-action-folder-link fal fa-folder-open fa-lg text-primary"></i></span>
          </span>
          </span>`
    : `<span class="rip-status rip-${status}">
          <span class="rip-status-notsubmited status-label text-muted mr-n4" data-aid="status-muted"><i class="far fa-fw fa-vote-nay mr-1"></i>${$Lang.BOM.RIPnotSubmitted}</span>
          <span class="rip-status-submited status-label text-success mr-n4" data-aid="status-submited"><i class="far fa-fw fa-vote-yea mr-1"></i>${$Lang.BOM.RIPfiles}</span>
          <span class="rip-status-inprocess status-label text-warning mr-n4" data-aid="status-warning"><i class="far fa-fw fa-sync-alt mr-1"></i>${$Lang.BOM.RIPinprocess}</span>
          <span class="rip-status-failed status-label text-danger mr-n4" data-aid="status-danger"><i class="far fa-fw fa-exclamation-triangle mr-1"></i>${$Lang.BOM.RIPfiles}</span>
          <span class="d-inline-flex text-nowrap ml-4 pl-2">
            <span class="rip-status-date">${submitDate}</span>
          </span>
          </span>`;
}
